import React from 'react'

type CleaningSuppliesProps = {
  className?: string
}

const _CleaningSupplies = (props: CleaningSuppliesProps) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10V3C10 2.44772 9.55228 2 9 2C8.44772 2 8 2.44772 8 3V10H10ZM6 3V10H5.42525C4.01063 10 2.78824 10.9882 2.49184 12.3714L0 24H18L15.5082 12.3714C15.2118 10.9882 13.9894 10 12.5748 10H12V3C12 1.34315 10.6569 0 9 0C7.34315 0 6 1.34315 6 3ZM5.42525 12H6H12H12.5748C13.0463 12 13.4538 12.3294 13.5526 12.7905L13.5975 13H4.40255L4.44744 12.7905C4.54625 12.3294 4.95371 12 5.42525 12ZM3.97397 15L2.47397 22H5.36343L5.67606 17.9235C5.7183 17.3729 6.19894 16.9607 6.74961 17.0029C7.30027 17.0452 7.71244 17.5258 7.67021 18.0765L7.3693 22H10.6537L10.3528 18.0765C10.3105 17.5258 10.7227 17.0452 11.2734 17.0029C11.824 16.9607 12.3047 17.3729 12.3469 17.9235L12.6595 22H15.526L14.026 15H3.97397Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_CleaningSupplies)
